module.exports = __webpack_public_path__ + "img/arrows.747fac18.svg";